import React, {Fragment, useState} from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import CircuitArrow from './CircuitArrow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { COLORS } from '../../styles/colors';
import VideoPreviewButton from '../VideoPreviewButton';
import LoadMoreIcon from '../LoadMoreIcon';
import InfiniteScroll from 'react-infinite-scroll-component';
import Search from './search';

const LIBRARIES = [
    { id: 'trainerExercises', name: 'My Library' },
    { id: 'corporateExercises', name: 'Fitbanx Library' },
    { id: 'favExercises', name: 'My Favorites' },
    { id: 'blocks', name: 'Pre-Made Block' },
]
const grid = 8;
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',

    // change background colour if dragging
    // background: isDragging ? 'lightgreen' : 'grey',

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    overflow: 'auto',
    background: isDraggingOver ? 'lightblue' : 'transparent',
    padding: grid,
    height: 400
});



const ExerciseCollection = ({ items, showBlockDetails, blocks, library, categories,
    equipment, blockCats, equipmentId, categoryId, blockCategoryId, changeSearch,
    changeFilter, parentType, setDraggingItem, fetchMore, isLoadMoreLibraryExercises, isLoadMoreLibraryBlocks, filter, toggleExerciseFavourite, user }) => {
    var circuitItem = items.shift();
        
    const renderMenuOptions = option => (
		<MenuItem key={option._id} value={option._id}>
			{option.name}
		</MenuItem>
	);

    const isLoadMore = library === 'blocks' ?  isLoadMoreLibraryBlocks : isLoadMoreLibraryExercises;

    return (
        <Droppable droppableId="droppable" isDropDisabled={true}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    id = "scrollableLibraryExercise"
                    style={getListStyle(snapshot.isDraggingOver)}>
                    <Grid container style={{ padding: 5 }}>
                        <Grid item xs={7} style={{ paddingRight: 10 }}>
                            <Search changeSearch={changeSearch}></Search>
                        </Grid>
                        <Grid item xs={5}>
                            <Draggable
                                key={circuitItem.id}
                                draggableId={circuitItem.id}
                                index={0}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                        )}>
                                        <CircuitArrow
                                            onMouseDown={() => setDraggingItem(circuitItem)}
                                        />

                                    </div>

                                )}
                            </Draggable>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                select
                                label="Library"
                                value={library}
                                onChange={(e, field) => changeFilter(e, 'library')}
                                margin="dense"
                                variant="outlined"
                            >
                                {Object.values(LIBRARIES).map(option => {
                                    if (option.id === 'blocks' && parentType === 'block') {
                                        return null;
                                    }
                                    return (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        {library === 'blocks' ?
                            <Grid item xs={8}
                                style={{ paddingRight: 10, paddingLeft: 10 }}>
                                <TextField
                                    select
                                    label="Category"
                                    value={blockCategoryId}
                                    onChange={(e, field) => changeFilter(e, 'blockCategoryId')}
                                    margin="dense"
                                    variant="outlined"
                                >
                                    <MenuItem key="no-equip" value="0">
                                        All
                                        </MenuItem>
                                    {Object.values(blockCats).map(renderMenuOptions)}
                                </TextField>
                            </Grid> :
                            <React.Fragment>
                                <Grid item xs={4}
                                    style={{ paddingRight: 10, paddingLeft: 10 }}>
                                    <TextField
                                        select
                                        label="Equipment"
                                        value={equipmentId}
                                        onChange={(e, field) => changeFilter(e, 'equipmentId')}
                                        margin="dense"
                                        variant="outlined"
                                    >
                                        <MenuItem key="no-equip" value="0">
                                            All
                                        </MenuItem>
                                        {Object.values(equipment).map(renderMenuOptions)}
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        select
                                        label="Body Target"
                                        value={categoryId}
                                        onChange={(e, field) => changeFilter(e, 'categoryId')}
                                        margin="dense"
                                        variant="outlined"
                                    >
                                        <MenuItem key="no-cat" value="0">
                                            All
                                        </MenuItem>
                                        {Object.values(categories).map(option => (
                                            <MenuItem key={option._id} value={option._id}>
                                                {option.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </React.Fragment>
                        }
                    </Grid>
                    <InfiniteScroll
                        dataLength={items.length} //This is important field to render the next data
                        next={() => fetchMore({
                            ...filter,
                            skip: items.length,
                        }, filter.library === 'blocks' ? false : true )
                        }
                        hasMore={isLoadMore}
                        scrollableTarget="scrollableLibraryExercise"
                        loader={
                            <LoadMoreIcon/>
                        }
                    >
                        {items.map((item, index) => (
                            <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index + 1}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                        )}>

                                        <div style={{ display: 'flex', width: '100%', padding: 5 }}
                                            onMouseDown={() => setDraggingItem(item)}>
                                            <FontAwesomeIcon icon="grip-vertical"
                                                style={{ marginRight: 5, color: COLORS.grey }} />
                                            {item.content}
                                            {
                                                item.type === 'block' ? (
                                                    <span
                                                        className="link"
                                                        onClick={() => showBlockDetails(item.id)}
                                                        style={{ float: 'right', marginLeft: 'auto', marginRight: 0 }}>
                                                        <FontAwesomeIcon icon="list"
                                                            style={{ marginRight: 5, color: COLORS.grey }} />
                                                    </span>
                                                ) : (
                                                        <Fragment>
                                                            <VideoPreviewButton
                                                                videoUrl={item.data.videoUrl}
                                                                title={item.data.name}
                                                                _id = {item.data._id}
                                                                favouriteByUsers = {item.data.favouriteByUsers}
                                                                user = { user}
                                                                library = { library}
                                                                isShowFavBtn = {true}
                                                                autoplay
                                                                loop
                                                                muted
                                                                toggleExerciseFavourite = { toggleExerciseFavourite }
                                                            />
                                                        </Fragment>
                                                    )
                                            }
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </InfiniteScroll>

                </div>
            )}
        </Droppable>

    )
}

export default ExerciseCollection;



// WEBPACK FOOTER //
// ./src/components/workouts/ExerciseCollection.js